/* eslint-disable no-nested-ternary */
/*
 * @Author: edvardchen
 * @Date:   2016-11-15 13:29:57
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-01-02 19:23:51
 */

import { connect } from 'react-redux';
import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import PropTypes from 'prop-types';

import { getPersonalUrl } from '../../utility/articleData';

import contextTypes from '../Share/contextTypes';
import { track, isQehId } from '../../utility';
import { contextTypes as routeContextTypes } from '../../HOCs/withRoute';
import TitleMark from '../Article_new/titleMark/index';
const QER = 96;
const v = [10002, 10001];
const isV = (code) => v.indexOf(code) > -1;

function Header({
  title,
  avatar,
  dataSrc,
  time,
  from,
  id,
  onAvatarClick,
  mergePageInfo,
  share,
  zimeitiId,
  sTitleLogo,
  isRumorTitle,
}) {
  const { 0: timeStr } = time.split(' ');
  const { sIdentification, iIdentifyCode, sName, sOrignalName, verifyAvatar } = mergePageInfo || {};
  const name = sOrignalName || sName || from;
  const isBigV = isV(iIdentifyCode);
  let iconStyle = {};
  if (isBigV && verifyAvatar) {
    iconStyle = {
      width: '16px',
      height: '16px',
      backgroundImage: `url(${verifyAvatar})`,
    };
  }
  let descrpJSX;
  const kalss = `G-can-be-select ${share ? 'is-share' : ''}`;
  isBigV && sIdentification && (descrpJSX = <span className="desc">{sIdentification}</span>);
  return (
    <header className={kalss} style={{ textAlign: 'left', paddingTop: '20px' }}>
      <TitleMark sTitleLogo={sTitleLogo} />
      <h1 style={{ display: 'inline' }}>{title}</h1>
      {isRumorTitle ? null : id && avatar && isQehId(zimeitiId) ? ( // 辟谣屏蔽企鹅号露出
        <div className="info-new">
          <div className="avatar">
            <div className="G-img-wrap" onClick={onAvatarClick}>
              <img src={avatar} alt="" />
              {isBigV && dataSrc !== QER ? <i className="n-from-icon-v" style={iconStyle} /> : null}
            </div>
          </div>
          <div className="middle">
            <span className="media">{name}</span>
            <span className="date">
              {descrpJSX}
              {timeStr}
            </span>
          </div>
        </div>
      ) : (
        <div className="info">
          <div className="cooperation">
            {avatar && <img src={avatar} alt="" />}
            <span>{from}</span>
            <span className="date">{timeStr}</span>
          </div>
        </div>
      )}
    </header>
  );
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  avatar: PropTypes.string,
  time: PropTypes.string,
  from: PropTypes.string,
  dataSrc: PropTypes.number,
  subscribed: PropTypes.bool,
  id: PropTypes.string, // funsionId
  onAvatarClick: PropTypes.func,
  onBtnClick: PropTypes.func,
};

class ArticleHeader extends React.PureComponent {
  static propTypes = Header.propTypes;

  static contextTypes = {
    ...contextTypes,
    ...routeContextTypes,
  };

  static shareLabel = 'FollowAccount';

  state = {};

  componentDidMount() {
    const { zimeitiId } = this.props;
    const ch = this.context.currentChannel;
    const listurl = getPersonalUrl({
      userId: zimeitiId,
      accountType: 9,
      from: '012',
      ch,
    });
    setTimeout(() => {
      this.setState({
        listurl: isQehId(zimeitiId) ? listurl : '', // `${window.location.origin}/tags/${id}?${querystring.stringify(params)}`,
      });
    });
  }

  @autobind
  onAvatarClick() {
    const { id, installed } = this.props;
    const url = this.state.listurl;
    if (!url) {
      return;
    }
    if (installed) {
      this.context.openQb({
        label: ArticleHeader.shareLabel,
        url,
      });
      return;
    }
    const reportLocation = this.props.share ? 'sharelp' : 'article';
    const reportObject = this.props.share ? 'sharelp_authorico' : 'official';
    const reportAction = this.props.share ? 'click' : 'open';
    track({
      location: reportLocation,
      object: reportObject,
      action: reportAction,
      ch: this.context.currentChannel,
      id,
    });
    browser.coolread.openExternalPage(url);
  }

  @autobind
  onBtnClick() {
    if (!this.state.listurl) {
      return;
    }
    this.context.downloadOrOpenQb({
      label: ArticleHeader.shareLabel,
      url: this.state.listurl,
      hideMaskModal: true,
    });
    if (this.props.share) {
      track({
        location: 'sharelp',
        object: 'sharelp_authorfollow',
        action: 'click',
        ch: this.context.currentChannel,
        id: this.props.id,
      });
    }
  }

  render() {
    return <Header {...this.props} onAvatarClick={this.onAvatarClick} onBtnClick={this.onBtnClick} />;
  }
}

export default connect(({ installer: { installed } }) => ({ installed }))(ArticleHeader);
